import styled from "styled-components";
import CommonBackground from "../../common/CommonBackground";
import { useSelector } from "react-redux";
import HalligalliUserRow from "./HalligalliUserRow";
import HalligalliHooks from "./HalligalliHooks";
import { useEffect, useMemo, useState } from "react";

const HalligalliPage = () => {
  const [click, setClick] = useState(false);
  const {
    halligalli: { turnStep, bellPress },
  } = useSelector(state => state.GameSlice);

  const { userId } = useSelector(state => state.LoginInfoSlice);
  const noticeText = {
    1: "놓여있는 카드 모양의 합이 5개가 되면 벨을 누르세요.",
    2: "최초로 벨을 누른 사람은 가져오기 or 나눠주기를 누르세요.",
    3: "게임이 종료되었습니다!",
  };
  const { OpenCard, PressBell, ShareCards, BringCard, checkPressAnswer } =
    HalligalliHooks();
  const checkPress = useMemo(
    () => bellPress[0]?.userId === userId,
    [userId, bellPress]
  );

  useEffect(() => {
    if (click) {
      setTimeout(() => {
        setClick(false);
      }, 1000);
    }
  }, [click]);

  return (
    <Wrap>
      <CommonBackground column={12} />
      <GameContentWrap>
        <PlayerContainer>
          <HalligalliUserRow indexArr={[4, 0, 2]} />
          <HalligalliUserRow indexArr={[3, 1, 5]} reverse={true} />
        </PlayerContainer>
        <BottomBar>{noticeText[turnStep]}</BottomBar>
        <CenterBar>
          <CenterArea>
            <CenterButton
              style={{
                opacity: (turnStep === 2 || click) && 0,
                cursor: (turnStep === 2 || click) && "default",
              }}
              onClick={() => {
                if (turnStep === 1) {
                  setClick(true);
                  PressBell();
                }
              }}>
              벨 버튼
            </CenterButton>
            {!checkPress ? (
              <CenterButton onClick={turnStep === 1 ? () => OpenCard() : null}>
                카드내기
              </CenterButton>
            ) : (
              <CenterButton
                onClick={checkPressAnswer ? BringCard : () => ShareCards()}>
                {checkPressAnswer ? "가져오기" : "나눠주기"}
              </CenterButton>
            )}
          </CenterArea>
        </CenterBar>
      </GameContentWrap>
    </Wrap>
  );
};

export default HalligalliPage;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border-left: 1px solid #e0e0e0;
`;

const GameContentWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 1;
  position: relative;
  flex-direction: column;
  justify-content: end;
`;

const CenterBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  position: absolute;
  height: 25%;
  left: 0;
  top: ${(100 / 12) * 4}%;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
`;

const CenterArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(60% + 1px);
  height: 100%;
  gap: 2px;
  translate: -0.5px 0;
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
`;
const BottomBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${100 / 12}%;
  background-color: #f5f5f5;
  border-right: 1px solid #e0e0e0;
  font-size: 12px;
  color: #242424;
`;

const PlayerContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
  flex-grow: 1;
`;

const CenterButton = styled.div`
  width: 25%;
  height: 33.33%;
  display: flex;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  color: #242424;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
